import { render, staticRenderFns } from "./Modelling.vue?vue&type=template&id=29450ab0&scoped=true&"
import script from "./Modelling.vue?vue&type=script&lang=js&"
export * from "./Modelling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29450ab0",
  null
  
)

export default component.exports